import { useLazyQuery } from '@apollo/client';

import UNIVERSITIES_QUERY from 'graphql/universities/queries/universities.graphql';
import {
  GetUniversitiesQuery,
  GetUniversitiesQueryVariables,
} from 'graphql/types';

export const useLazyUniversities = (variables: GetUniversitiesQueryVariables) =>
  useLazyQuery<GetUniversitiesQuery, GetUniversitiesQueryVariables>(
    UNIVERSITIES_QUERY,
    {
      variables,
    }
  );
